import { render, staticRenderFns } from "./FloorAreaCellar.vue?vue&type=template&id=482a8e9c&"
import script from "./FloorAreaCellar.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaCellar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports